const get = require('lodash/get')

const generateShipmentItems = (counts) => {
  return Object.keys(counts).reduce((acc, product) => {
    const value = {
      sku: product,
      quantity: get(counts[product], 'quantity', 0),
      price: counts[product].sellprice || 0
    }

    acc.push(value)
    return acc
  }, [])
}
const getCustomerDetails = (location = {}) => {
  const customer = {
    fullName: location.name,
    address: location.address,
    state: location.state,
    country: location.country,
    city: location.city,
    status: location.status === true ? 'Active' : 'Inactive',
    email: location.email,
    phone: location.phoneNumber,
    name: location.ownerName
  }

  return customer
}

const generateSalesOrder = (shipment, locationById) => {
  // Transform the shipment object as needed
  const items = generateShipmentItems(shipment.counts)
  const destination = locationById[shipment.destinationId]
  const data = {
    supplierId: get(locationById[shipment.originId], 'code'),
    destinationId: get(locationById[shipment.destinationId], 'uuid'),
    orderId: shipment.shipmentNumber,
    status: shipment.deleted ? 'cancelled' : 'accepted',
    orderType: 'main',
    items,
    customer: getCustomerDetails(destination)

  }

  return data
}

module.exports = generateSalesOrder
